import type { Translations } from './en';

export const de: Translations = {
  nav: {
    services: 'Leistungen',
    portfolio: 'Portfolio',
    starModel: 'Sternmodell',
    partners: 'Partner',
    about: 'Uber uns',
    contact: 'Kontakt',
    getStarted: 'Loslegen',
    closeMenu: 'Menu schliessen',
    openMenu: 'Menu offnen',
  },
  hero: {
    title: 'Die unternehmerische Exzellenz von morgen aufbauen',
    subtitle: 'Impresstars orchestriert leistungsstarke Geschaeftsablaeufe durch unser innovatives Star-Model-System. Von der Gruendung bis zur Wachstumsstrategie sind wir Ihr Partner fuer operative Exzellenz.',
    exploreServices: 'Leistungen entdecken',
    learnMore: 'Mehr erfahren',
  },
  services: {
    eyebrow: 'Was wir tun',
    title: 'Unsere Leistungen',
    incorporation: {
      title: 'Gruendungsservices',
      description: 'Starten Sie Ihr Unternehmen richtig mit unserem vereinfachten Gruendungsprozess. LLC, Corp oder Non-profit einfach eingerichtet.',
    },
    aiSolutions: {
      title: 'KI-Loesungen',
      description: 'Massgeschneiderte KI-Integrationsdienste inklusive Machine-Learning-Modelle, natuerliche Sprachverarbeitung und automatisierte Entscheidungssysteme.',
    },
    b2bSolutions: {
      title: 'B2B-Loesungen',
      description: 'Umfassende B2B-Dienstleistungen inklusive Partnerschaftsentwicklung, Lieferkettenoptimierung und Outsourcing von Geschaeftsprozessen.',
    },
    marketingStrategy: {
      title: 'Marketingstrategie',
      description: 'Datengetriebene Marketingstrategien, die auf Ihre Geschaeftsziele zugeschnitten sind, inklusive Marktanalyse und Wachstumsplanung.',
    },
    businessSoftware: {
      title: 'Geschaeftssoftware',
      description: 'Identifizieren und implementieren Sie die richtigen Softwareloesungen, um Ihre Ablaeufe zu optimieren und die Produktivitaet zu steigern.',
    },
    brandDesign: {
      title: 'Markendesign',
      description: 'Professionelles Logodesign, Entwicklung von Markenidentitaet und Marketingmaterialien, die bleibenden Eindruck hinterlassen.',
    },
    businessConsulting: {
      title: 'Unternehmensberatung',
      description: 'Strategische Fuehrung zur Optimierung Ihrer Ablaeufe und Beschleunigung des Wachstums durch bewaehrte Methoden.',
    },
    ctaTitle: 'Bereit, Ihr Unternehmen zu transformieren?',
    ctaText: 'Lassen Sie uns besprechen, wie unsere Dienste Ihnen helfen koennen, Ihre Ziele zu erreichen.',
    ctaButton: 'Loslegen',
  },
  starModel: {
    eyebrow: 'Verbunden durch Design',
    title: 'Sternmodelle',
    description: 'Entdecken Sie unser Oekosystem spezialisierter Geschaeftseinheiten und die zugrundeliegende Betriebsmethodik.',
    learnHow: 'So funktioniert das Sternmodell',
    captionLeft: 'Vernetzte Ablaeufe',
    captionRight: 'Gemeinsamer Schwung',
    cleaningEdge: {
      title: 'Cleaning EDGE',
      status: 'Aktiv',
      description: 'Professionelle Reinigungsdienste, neu erfunden durch Technologie und aussergewoehnliche Servicequalitaet.',
      details: 'Cleaning EDGE ist ein professionelles Reinigungsunternehmen, das sich auf zuverlaessige Wohn- und Gewerbereinigung spezialisiert hat, inklusive Post-Bau-Reinigung und Auto-Aufbereitung, mit digitalen Workflows, die Buchung, Kommunikation und Service-Nachverfolgung erleichtern.',
    },
    ozean: {
      title: 'Ozean',
      status: 'In Entwicklung',
      description: 'Eine Stock-Audio-Plattform, die Sound-Ressourcen fuer Ersteller, Editoren, Marken und Geschichtenerzaehler bietet.',
      details: 'Ozean konzentriert sich auf kuratierte Stock-Audios und hilft kreativen Teams, Tracks und Sound-Elemente fuer die Content-Produktion zu finden.',
    },
    visitWebsite: 'Website besuchen',
  },
  testimonials: {
    eyebrow: 'Kundengeschichten',
    title: 'Kundenstimmen',
    description: 'Verlassen Sie sich nicht nur auf unser Wort — hoeren Sie, was unsere Kunden ueber die Zusammenarbeit mit Impresstars zu sagen haben.',
    j94Designs: 'Impresstars hat uns bei HR-Beratung unterstützt und auch geholfen, wesentliche Teile unserer Wix-Website zu erstellen.',
    craftPapi: 'Impresstars hat einen praktischen Marketingplan fuer unser Team entwickelt, der unsere Kampagnen und Prioritaeten viel klarer machte.',
    pawStuffs: 'Impresstars unterstuetzt weiterhin unsere Shopify-Seite und bietet laufenden Service-Support, waehrend unser Shop waechst.',
  },
  portfolio: {
    eyebrow: 'Ausgewaehlte Arbeiten',
    title: 'Unser Portfolio',
    description: 'Entdecken Sie unsere aktuellen Projekte und Erfolgsgeschichten in verschiedenen Branchen und Diensten.',
    filterAll: 'Alle',
    filterWebsites: 'Websites',
    filterApps: 'Apps und Tools',
    filterGames: 'Spiele',
    filterConsulting: 'Beratung',
    production: 'Produktion',
    showcase: 'Showcase',
    viewCaseStudy: 'Fallstudie ansehen',
    visitSite: 'Seite besuchen',
    openProject: 'Projekt offnen',
    viewServices: 'Unsere Dienste ansehen',
    startProject: 'Projekt starten',
    filterAllProjects: 'Alle Projekte',
    filterRealWorld: 'Produktion',
    filterShowcase: 'Showcase',
    sortFeatured: 'Empfohlen',
    sortAZ: 'Titel: A-Z',
    sortZA: 'Titel: Z-A',
    sortLabel: 'Sortieren nach:',
    reset: 'Zuruecksetzen',
    showing: 'Zeige',
    of: 'von',
    projects: 'Projekten',
    noProjects: 'Fuer diesen Filter wurden noch keine Projekte gefunden.',
    visitProjectWebsite: 'Projekt-Website besuchen',
    catBrandWebsite: 'Marken-Website',
    catWebDevelopment: 'Webentwicklung',
    catEcommerceWebsite: 'E-commerce-Website',
    catBusinessWebsite: 'Geschaefts-Website',
    catWebsite: 'Website',
    catJewelleryBrand: 'Juwelier-Marke',
    catWebApp: 'Web-App',
    catInteractiveApp: 'Interaktive App',
    catUtilityTool: 'Dienstprogramm',
    cat3DWebSandbox: '3D-Web-Sandbox',
    catWebGame: 'Web-Spiel',
    catGameExperience: 'Spielerlebnis',
    catConsultingMarketingPlan: 'Beratung und Marketingplan',
    desc: {
      snouts: 'Web-Arbeiten zur Unterstuetzung der Online-Markenpraesenz von Snouts.',
      innovaPro: 'Website-Lieferung fuer Innova Pro mit Fokus auf klare Servicepraesentation und starke Performance.',
      pawstuffs: 'E-commerce-Webpraesenz und Shop-Support fuer Pawstuffs.',
      cleaningEdge: 'Website- und digitale Praesenz-Arbeiten fuer Cleaning EDGE.',
      cheesePanic: 'Katze jagt Maus, Maus will Kaese. Ein chaotisches kleines Web-Spiel.',
      cleaningEdgeApp: 'Operations-fokussierte Self-Service-Plattform fuer Cleaning EDGE-Kunden und -Mitarbeiter. Testen Sie die Dev-Demo mit Passwort cleaningEDGE und waehlen Sie Legacy Mode.',
      angoloDiamonds: 'Webentwicklungsarbeiten fuer Angolo Diamonds.',
      craftPapiGrowth: 'Beratungs- und Marketingplan-Entwicklung fuer Craft Papi zur Staerkung von Positionierung und Wachstumsumsetzung.',
      roboticVoiceClicker: 'Sprachgesteuerte Clicker-Erfahrung mit verspielter Echsen-Button-Interaktion.',
      cheatCounter: 'Jorge schaute sich wieder die oberste Karte seines Decks an. Jemand musste mitzaehlen.',
      klondikeSolitaire: 'Praesentation und Interaktion eines vom klassischen Solitaer inspirierten Web-Spiels.',
      universeAdventure: 'Weltraum-Abenteuerkonzept mit Galaxiereisen und schiffbasierter Erkundung.',
      interiorDesign3d: 'Eine Three.js-Browser-Sandbox zum Importieren von 3D-Modellen und Erstellen von Inneneinrichtungen.',
      pavillionJewellery: 'Markenorientierte Website-Praesentation fuer Pavillion Jewellery.',
      hauntedGalleria: 'Eine immersive, dunkel gestaltete Showcase-Website fur ein Geistergalerie-Erlebnis mit atmospharischen Visuals und grusligen Animationen.',
    },
  },
  partners: {
    eyebrow: 'Vertrauenswuerdige Technologie',
    title: 'Tools, die wir nutzen und empfehlen',
    description: 'Dies sind Plattformen, mit denen wir aktiv arbeiten und die wir unseren Kunden empfehlen. Wenn Sie sich ueber unsere Links anmelden, koennen wir eine Provision verdienen — ohne zusatzliche Kosten fuer Sie.',
    teaserEyebrow: 'Vertrauenswuerdige Technologie',
    teaserTitle: 'Tools, die wir empfehlen',
    seeAllPartners: 'Alle Partner ansehen',
    getStarted: 'Loslegen',
    ctaTitle: 'Benoetigen Sie Hilfe bei der Wahl des richtigen Stacks?',
    ctaText: 'Wir evaluieren, implementieren und integrieren Tools in Ihren Workflow. Lassen Sie uns die Technik uebernehmen, damit Sie sich auf Ihr Geschaefet konzentrieren koennen.',
    ctaButton: 'Sprechen Sie mit uns',
    disclaimer: 'Einige Links auf dieser Seite sind Empfehlungslinks. Impresstars kann eine Provision verdienen, wenn Sie sich anmelden — ohne zusaetzliche Kosten fuer Sie.',
    catProductivity: 'Produktivitaet',
    catAIVoice: 'KI und Sprache',
    catBusinessPhone: 'Geschaeefstelefon',
    catAIWebBuilder: 'KI-Web-Builder',
  },
  about: {
    eyebrow: 'Unser Zweck',
    title: 'Ueber Impresstars',
    p1: 'Bei Impresstars glauben wir an die Transformation von Geschaeftsablaeufen durch Innovation und Exzellenz. Unsere Mission ist es, Unternehmen zu helfen, ihr volles Potenzial zu erreichen, indem wir modernste Loesungen und bewaehrte Methoden implementieren.',
    p2: 'Gegruendet auf den Prinzipien operativer Exzellenz und nachhaltigem Wachstum, haben wir unser einzigartiges Star-Model-System entwickelt, das zahlreichen Unternehmen zu bemerkenswertem Erfolg verholfen hat.',
  },
  clients: {
    title: 'Unsere Kunden',
    description: 'Wir sind stolz darauf, mit diesen Organisationen zu arbeiten und ihnen durch unsere Dienste und engagierte Unterstuetzung beim Wachstum zu helfen.',
  },
  techPlatforms: {
    title: 'Technologien und Plattformen, die wir unterstuetzen',
    description: 'Wir koennen bei Implementierung, Optimierung oder Support fuer diese Tools und Plattformen helfen.',
    catEcommerce: 'E-commerce und Websites',
    catAI: 'KI und Automatisierung',
    catMarketing: 'Marketing und Wachstum',
    catCloud: 'Cloud und Infrastruktur',
    catCreative: 'Kreative- und Markenproduktion',
    focusEcommerce: 'Kernkompetenz: Launch und Support von konversionsorientierten Shops und Geschaeftswebsites.',
    focusAI: 'Kernkompetenz: praktische KI-Einfuehrung und Workflow-Automatisierung fuer wachsende Teams.',
    focusMarketing: 'Kernkompetenz: Performance-Tracking, Kampagnenausfuehrung und grundlegende SEO.',
    focusCloud: 'Kernkompetenz: zuverlaessige Bereitstellung und Umgebungs-Support fuer moderne Web-Operationen.',
    focusCreative: 'Kernkompetenz: Marken-Ausfuehrungs-Assets, die Marketing und Produkt-Erzaehlung unterstuetzen.',
  },
  contact: {
    title: 'Kontakt aufnehmen',
    description: 'Bereit, Ihr Unternehmen zu transformieren? Senden Sie uns eine Nachricht und wir melden uns innerhalb von 24 Stunden.',
    name: 'Name',
    namePlaceholder: 'Ihr Name',
    email: 'E-Mail',
    emailPlaceholder: 'ihre@email.com',
    reason: 'Kontaktgrund',
    reasonPlaceholder: 'Einen Grund auswaehlen',
    message: 'Nachricht',
    messagePlaceholder: 'Wie koennen wir Ihnen helfen?',
    sending: 'Senden...',
    send: 'Nachricht senden',
    successTitle: 'Nachricht gesendet!',
    successText: 'Danke, dass Sie uns kontaktiert haben. Wir melden uns in Kuerze.',
    sendAnother: 'Weitere Nachricht senden',
    recaptchaError: 'Bitte bestaetigen Sie die reCAPTCHA-Verifizierung.',
    submitError: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut oder senden Sie uns eine E-Mail.',
    reasons: {
      incorporationServices: 'Gruendungsservices',
      aiSolutions: 'KI-Loesungen',
      b2bSolutions: 'B2B-Loesungen',
      marketingStrategy: 'Marketingstrategie',
      businessSoftware: 'Geschaeftssoftware',
      brandDesign: 'Markendesign',
      businessConsulting: 'Unternehmensberatung',
      websiteDevelopment: 'Webentwicklung',
      websiteSupport: 'Website-Support / Wartung',
      ecommerceSupport: 'E-commerce-Support',
      generalQuestion: 'Allgemeine Frage',
      partnership: 'Partnerschaftsmoeglichkeit',
    },
  },
  footer: {
    tagline: 'Transformation von Geschaeftsablaeufen durch Innovation und Exzellenz.',
    quickLinks: 'Schnelllinks',
    starModels: 'Sternmodelle',
    legal: 'Rechtliches',
    termsConditions: 'AGB',
    privacyPolicy: 'Datenschutzerklaerung',
    contactTitle: 'Kontakt',
    city: 'London, ON',
    country: 'Kanada',
    rightsReserved: 'Impresstars. Alle Rechte vorbehalten.',
    notALawFirm: 'Impresstars ist keine Anwaltskanzlei und bietet keine Rechtsberatung.',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    metaDescription: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    heading: 'Seite nicht gefunden',
    text: 'Die gesuchte Seite existiert nicht oder wurde moeglicherweise verschoben. Bringen wir Sie zurueck auf Kurs.',
    backHome: 'Zurueck zur Startseite',
    contactUs: 'Kontakt',
    portfolio: 'Portfolio',
    services: 'Leistungen',
  },
  caseStudy: {
    notFound: 'Fallstudie nicht gefunden',
    returnHome: 'Zurueck zur Startseite',
    backToPortfolio: 'Zurueck zum Portfolio',
    client: 'Kunde:',
    challenge: 'Die Herausforderung',
    solution: 'Unsere Loesung',
    keyResults: 'Wichtige Ergebnisse',
    technologiesUsed: 'Verwendete Technologien',
    visitProject: 'Projekt besuchen',
    items: {
      cleaningEdgePlatform: {
        title: 'Cleaning EDGE Plattform',
        category: 'Webentwicklung',
        client: 'Cleaning EDGE',
        description: 'Eine umfassende digitale Plattform zur Verwaltung von Reinigungsdiensten, inklusive Terminplanung, Teamverwaltung und Kundenfeedback.',
        challenge: 'Der Kunde benoetigte eine skalierbare Loesung zur Verwaltung seiner wachsenden Reinigungsdienst-Operationen, zur Behandlung von Kundenbuchungen und zur Optimierung der Teamplanung an mehreren Standorten.',
        solution: 'Wir entwickelten eine massgeschneiderte Web-Plattform, die Buchungsverwaltung, Teamplanung und Echtzeit-Tracking integriert. Die Loesung umfasst ein Kundenportal, ein Admin-Dashboard und eine mobilfreundliche Oberflaeche fuer Reinigungsteams.',
        results: [
          'Reduzierung von Planungskonflikten um 95%',
          'Erhoehung der Kundenzufriedenheit auf 98%',
          'Verbesserung der Teameffizienz um 40%',
          'Ermöglichung der Expansion auf 3 neue Standorte',
        ],
      },
      aiAnalyticsDashboard: {
        title: 'KI-gestuetztes Analytics-Dashboard',
        category: 'KI-Loesungen',
        client: 'TechVision Inc.',
        description: 'Massgeschneidertes Analytics-Dashboard mit Machine Learning zur Vorhersage von Geschaeftstrends und Optimierung von Ablaeufen.',
        challenge: 'Der Kunde hatte Schwierigkeiten, seine umfangreiche Datensammlung zu verstehen, und benoetigte praediktive Erkenntnisse fuer bessere Geschaeftsentscheidungen.',
        solution: 'Wir implementierten ein Machine-Learning-System, das historische Daten analysiert, Trends vorhersagt und ueber eine intuitive Dashboard-Oberflaeche umsetzbare Erkenntnisse liefert.',
        results: [
          'Erhoehung der Vorhersagegenauigkeit um 85%',
          'Reduzierung der Entscheidungszeit um 60%',
          'Generierung von 2M$ Kosteneinsparungen',
          'Verbesserung des Bestandsmanagements um 45%',
        ],
      },
      globalMarketingCampaign: {
        title: 'Globale Marketingkampagne',
        category: 'Marketingstrategie',
        client: 'Global Solutions Ltd',
        description: 'Umfassende digitale Marketingstrategie, die die Marktpraesenz des Kunden auf drei Kontinenten erweiterte.',
        challenge: 'Der Kunde musste seine Marktpraesenz global erweitern und dabei konsistente Markenkommunikation und Engagement ueber verschiedene kulturelle Kontexte hinweg aufrechterhalten.',
        solution: 'Wir entwickelten eine Multichannel-Marketingstrategie mit lokalisierten Inhalten, gezielter Werbung und kultureller Anpassung der Marketingmaterialien.',
        results: [
          'Erreicht ueber 2M neue potenzielle Kunden',
          'Steigerung des globalen Umsatzes um 150%',
          'Verbesserung der Markenbekanntheit um 80%',
          'Generiert 300% ROI auf Marketingausgaben',
        ],
      },
      hauntedGalleria: {
        title: 'Haunted Galleria',
        category: 'Webdesign und Entwicklung',
        client: 'Haunted Galleria',
        description: 'Eine immersive, dunkel gestaltete Showcase-Website fur ein Geistergalerie-Erlebnis — mit atmospharischen Visuals, grusligen Animationen und markanter Typografie.',
        challenge: 'Der Kunde benotige einen Webauftritt, der zur dramatischen, mysteriosen Natur seines Geistergalerie-Konzepts passte.',
        solution: 'Wir haben eine vollstandig individuelle Website mit dunkler Atmosphare, Parallax-Effekten und horrorinspirierter Typografie erstellt, um Spannung aufzubauen.',
        results: [
          'Unverwechselbare Markenidentitat in einem Nischenmarkt',
          'Immersives UX, das Besucher langer engagiert halt',
          'Vollstandig responsiv auf allen Geraten',
          'Optimiert fur schnelle Ladezeiten trotz reicher visueller Effekte',
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: 'Gruendungsservices',
      metaDescription: 'Starten Sie Ihre Geschaeftsreise mit Zuversicht. Unsere Gruendungsservices bieten eine solide Grundlage fuer den zukuenftigen Erfolg Ihres Unternehmens.',
      intro: 'Starten Sie Ihre Geschaeftsreise mit Zuversicht. Unsere Gruendungsservices bieten eine solide Grundlage fuer den zukuenftigen Erfolg Ihres Unternehmens.',
      disclaimer: 'Hinweis: Impresstars ist keine Anwaltskanzlei und bietet keine Rechtsberatung. Wir empfehlen, einen qualifizierten Anwalt fuer rechtliche Fuehrung zu konsultieren.',
      structureOptions: 'Gesellschaftsstruktur-Optionen',
      structureItems: [
        'Limited Liability Company (LLC)',
        'Corporation (C-Corp, S-Corp)',
        'Gemeinnuetzige Organisation',
        'Partnerschaftsgruendungen',
      ],
      included: 'Was enthalten ist',
      includedItems: [
        'Firmennamenssuche',
        'Gruendungsurkunde',
        'EIN-Registrierung',
        'Betriebsvereinbarung',
      ],
      ctaTitle: 'Bereit zu gruenden?',
      ctaText: 'Lassen Sie uns die beste Struktur fuer Ihr Unternehmen besprechen und Sie auf den richtigen Weg bringen.',
      ctaButton: 'Beratung vereinbaren',
    },
    aiSolutions: {
      title: 'KI-Loesungen',
      metaDescription: 'Transformieren Sie Ihr Unternehmen mit modernster Kuenstliche Intelligenz, die auf Ihre spezifischen Beduerfnisse zugeschnitten ist.',
      intro: 'Transformieren Sie Ihr Unternehmen mit modernster Kuenstliche Intelligenz, die auf Ihre spezifischen Beduerfnisse zugeschnitten ist.',
      servicesTitle: 'KI-Dienste',
      servicesItems: [
        'Machine-Learning-Modelle',
        'Natuerliche Sprachverarbeitung',
        'Computer-Vision-Loesungen',
        'Praediktive Analytik',
      ],
      implAreas: 'Implementierungsbereiche',
      implItems: [
        'Kundenservice-Automatisierung',
        'Datenanalyse und Erkenntnisse',
        'Prozessoptimierung',
        'Entscheidungsunterstuetzungssysteme',
      ],
      ctaTitle: 'Bereit, KI zu implementieren?',
      ctaText: 'Lassen Sie uns erkunden, wie KI Ihre Geschaeftsablaeufe revolutionieren und Wachstum foerdern kann.',
      ctaButton: 'Loslegen',
    },
    b2bSolutions: {
      title: 'B2B-Loesungen',
      metaDescription: 'Optimieren Sie Ihre Business-to-Business-Operationen mit unseren umfassenden, fuer moderne Unternehmen entwickelten Loesungen.',
      intro: 'Optimieren Sie Ihre Business-to-Business-Operationen mit unseren umfassenden, fuer moderne Unternehmen entwickelten Loesungen.',
      coreServices: 'Kerndienste',
      coreServicesItems: [
        'Lieferkettenoptimierung',
        'Partnerschaftsentwicklung',
        'Prozess-Outsourcing',
        'Strategische Planung',
      ],
      benefits: 'Vorteile',
      benefitsItems: [
        'Erhoehung der Effizienz',
        'Kostenreduzierung',
        'Markterweiterung',
        'Umsatzwachstum',
      ],
      ctaTitle: 'Transformieren Sie Ihre B2B-Operationen',
      ctaText: 'Lassen Sie uns Ihre Geschaeftsbeziehungen und Prozesse fuer maximale Effizienz optimieren.',
      ctaButton: 'Kontakt',
    },
    marketingStrategy: {
      title: 'Marketingstrategie',
      metaDescription: 'Entwickeln Sie eine leistungsstarke Marketingstrategie, die Wachstum vorantreibt und Ihre Zielgruppe erreicht.',
      intro: 'Entwickeln Sie eine leistungsstarke Marketingstrategie, die Wachstum vorantreibt und Ihre Zielgruppe erreicht.',
      strategyComponents: 'Strategiekomponenten',
      strategyItems: [
        'Marktanalyse',
        'Wettbewerbsforschung',
        'Zielgruppenprofilierung',
        'Kanalstrategie',
      ],
      deliverables: 'Lieferobjekte',
      deliverablesItems: [
        'Marketingplan',
        'Content-Strategie',
        'Kampagnen-Roadmap',
        'ROI-Projektionen',
      ],
      ctaTitle: 'Bereit zu wachsen?',
      ctaText: 'Lassen Sie uns eine Marketingstrategie erstellen, die Ihr Unternehmen auf das naechste Level bringt.',
      ctaButton: 'Planung starten',
    },
    brandDesign: {
      title: 'Markendesign',
      metaDescription: 'Erstellen Sie eine einpruegsame Markenidentitaet, die bei Ihrer Zielgruppe anklingt und am Markt heraussteht.',
      intro: 'Erstellen Sie eine einpruegsame Markenidentitaet, die bei Ihrer Zielgruppe anklingt und am Markt heraussteht.',
      designServices: 'Design-Dienste',
      designItems: [
        'Logodesign',
        'Markenrichtlinien',
        'Visuelle Identitaet',
        'Marketingmaterialien',
      ],
      deliverables: 'Lieferobjekte',
      deliverablesItems: [
        'Marken-Styleguide',
        'Logo-Paket',
        'Farbpalette',
        'Typografie-System',
      ],
      ctaTitle: 'Bereit fuer ein neues Erscheinungsbild?',
      ctaText: 'Lassen Sie uns eine Markenidentitaet schaffen, die Ihre Vision einfängt und Ihre Zielgruppe erreicht.',
      ctaButton: 'Design-Prozess starten',
    },
    businessConsulting: {
      title: 'Unternehmensberatung',
      metaDescription: 'Erhalten Sie fachkundige Fuehrung zur Optimierung Ihrer Ablaeufe und Beschleunigung des Unternehmenswachstums durch bewaehrte Methoden.',
      intro: 'Erhalten Sie fachkundige Fuehrung zur Optimierung Ihrer Ablaeufe und Beschleunigung des Unternehmenswachstums durch bewaehrte Methoden.',
      consultingAreas: 'Beratungsbereiche',
      consultingItems: [
        'Strategische Planung',
        'Operations-Optimierung',
        'Finanzanalyse',
        'Wachstumsstrategie',
      ],
      benefits: 'Vorteile',
      benefitsItems: [
        'Verbesserte Effizienz',
        'Kostenreduzierung',
        'Umsatzwachstum',
        'Bessere Entscheidungsfindung',
      ],
      ctaTitle: 'Bereit zu optimieren?',
      ctaText: 'Lassen Sie uns Ihr Unternehmen analysieren und eine Roadmap fuer nachhaltiges Wachstum erstellen.',
      ctaButton: 'Beratung buchen',
    },
    businessSoftware: {
      title: 'Geschaeftssoftware-Loesungen',
      metaDescription: 'Transformieren Sie Ihre Geschaeftsablaeufe mit sorgfaeltig ausgewaehlten und implementierten Softwareloesungen, die Prozesse optimieren und die Effizienz steigern.',
      intro: 'Transformieren Sie Ihre Geschaeftsablaeufe mit sorgfaeltig ausgewaehlten und implementierten Softwareloesungen, die Prozesse optimieren und die Effizienz steigern.',
      ourApproach: 'Unser Ansatz',
      approachItems: [
        'Geschaeftsprozessanalyse',
        'Software-Anforderungsermittlung',
        'Loesungsbewertung und -auswahl',
        'Implementierung und Integration',
      ],
      solutionAreas: 'Loesungsbereiche',
      solutionItems: [
        'ERP-Systeme',
        'CRM-Plattformen',
        'Projektmanagement-Tools',
        'Massgeschneiderte Softwareentwicklung',
      ],
      ctaTitle: 'Bereit, Ihre Ablaeufe zu optimieren?',
      ctaText: 'Lassen Sie uns die perfekten Softwareloesungen identifizieren, um Ihre Geschaeftsprozesse zu transformieren.',
      ctaButton: 'Beratung vereinbaren',
    },
  },
  seo: {
    homeTitle: 'Die unternehmerische Exzellenz von morgen aufbauen',
    homeDescription: 'Impresstars orchestriert leistungsstarke Geschaeftsablaeufe durch unser innovatives Star-Model-System. Von der Gruendung bis zur Wachstumsstrategie sind wir Ihr Partner fuer operative Exzellenz.',
    portfolioTitle: 'Portfolio',
    portfolioDescription: 'Entdecken Sie unsere vollstaendige Sammlung erfolgreicher Projekte und Fallstudien in verschiedenen Branchen.',
    partnersTitle: 'Empfohlene Tools und Partner',
    partnersDescription: 'Tools und Plattformen, die Impresstars nutzt und Kunden empfiehlt. Starten Sie mit erstklassiger Technologie ueber unsere Empfehlungslinks.',
  },
  languageSwitcher: {
    label: 'Sprache',
  },
};
